<template>
  <div>
    <div v-if="!noMoreShow">
      <div
        class="flex serviceListMessage"
        v-for="(item, index) in serviceListMessageList"
        :key="index"
      >
        <div class="serviceListMessage_left">
          <div class="serviceListMessage_icon">
            {{ item.oneLabel }}/{{ item.twoLabel }}
          </div>
          <h3 @click="getServiceDetails(item.id)">{{ item.title }}</h3>
          <div class="flex-center-between service_money">
            <p class="service_money_box">
              ￥<span class="red">{{ item.money }}</span
              ><span class="unit">元</span>
            </p>
            <p>
              <i class="el-icon-location-outline"></i>
              {{ item.addProvince }}
              <span v-if="item.addCity">·{{ item.addCity}}</span>
              <span v-if="item.addArea">·{{ item.addArea }}</span>
            </p>
          </div>
          <div class="flex-center-between">
            <div class="flex-item-center">
              <i
                class="el-icon-office-building"
                style="color: #6e6e6e; margin-right: 8px"
              ></i>
              <p
                @click="getComDetials(item.enterpriseUuid)"
                style="cursor: pointer"
              >
                {{ item.company }}
              </p>
            </div>
            <div class="serviceListMessage_btn" @click="getInquiry(item)">
              <img src="../../../../assets/supplyHome/chuizi.jpg" alt="" />
              <p>立即询价</p>
            </div>
          </div>
        </div>
        <div class="serviceListMessage_right">
          <img
            :src="imgs.url"
            alt=""
            v-for="(imgs, imgsIndex) in item.imgPaths.slice(0, 3)"
            :key="imgsIndex"
          />
        </div>
      </div>
      <div style="text-align: right; width: 100%; margin-top: 30px">
        <el-pagination
          style="margin-right: -10px"
          @current-change="handleCurrentChange"
          @prev-click="handleCurrentChange"
          @next-click="handleCurrentChange"
          layout="total,prev, pager, next,jumper"
          :current-page="current"
          :page-size="pageSize"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <div v-else>
      <el-empty description="暂无数据"  :image-size="100"/>
    </div>

    <!-- 立即询价 -->
    <inquire ref="inquiryRef"></inquire>
  </div>
</template>

<script>
import { askInquiry, serviceListPage } from "../../../../utils/interface";
import inquire from "../details/inquire";

export default {
  components: { inquire },
  data() {
    return {
      current: 1,
      pageSize: 10,
      total: 0,
      title: "",
      classifyOne: "",
      classifyTwo: "",
      serviceListMessageList: [],
      noMoreShow: false,
    };
  },
  methods: {
    init(param) {
      this.title = param.title;
      this.classifyOne = param.classifyOne;
      this.classifyTwo = param.classifyTwo;
      this.type = param.type;
      this.publishDate = param.publishDate;
      this.publishDateorderBy = param.publishDateorderBy;
      this.pjNum = param.pjNum;
      this.pjNumorderBy = param.pjNumorderBy;
      this.price = param.price;
      this.priceorderBy = param.priceorderBy;
      this.current = 1;
      this.pageSize = 10,
      this.getServiceList();
    },
    handleCurrentChange(val) {
      this.current = val;
      window.scrollTo(0,0);
      this.getServiceList();
    },
    getServiceList() {
      this.serviceListMessageList = [];
      let param = {
        title: this.title,
        classifyOne: this.classifyOne,
        classifyTwo: this.classifyTwo,
        type: this.type == "全部" ? "" : this.type,
        publishDate: this.publishDate,
        publishDateorderBy: this.publishDateorderBy,
        pjNum: this.pjNum,
        pjNumorderBy: this.pjNumorderBy,
        price: this.price,
        priceorderBy: this.priceorderBy,
        currentPage: this.current,
        pageSize: this.pageSize,
      };
      serviceListPage(param).then((res) => {
        this.serviceListMessageList = res.records;
        this.total = Number(res.total);
       
        if (res.records.length > 0) {
          this.noMoreShow = false;
        } else {
          this.noMoreShow = true;
        }
      });
    },
    getServiceDetails(id) {
      console.log("-------id--------" + id);
      let routeData = this.$router.resolve({
        path: `/serviceDetails`,
        query: { uuid: id },
      });
      window.open(routeData.href, "_blank");
      // this.$router.push({name:"serviceDetails",params:{uuid:id}});
    },
    getComDetials(enterpriseUuid) {
      let routeData = this.$router.resolve({
        name: `printServiceIndex`,
        params: { enterPriseId: enterpriseUuid },
      });
      window.open(routeData.href, "_blank");
      // this.$router.push({name:"qualityServiceProviderDetails",});
    },
    getInquiry(item) {
      console.log("--------state-------------", this.$store.state);
      if (this.$store.state.isLogin) {
        if (
          item.enterpriseUuid == this.$store.state.isUsermessage.enterpriseUuid
        ) {
          this.$message.error("不能询价自己的服务");
          return false;
        }

        askInquiry({ serviceId: item.id }).then((res) => {
          if (res.success) {
            let list = {
              id: item.id,
              title: item.title,
              classifyOne: item.classifyOne,
              classifyTwo: item.classifyTwo,
              type: item.type,
              money: item.money,
              serviceCreatuser: item.createUser,
            };
            this.$refs.inquiryRef.init(list);
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.$message({
          type: "success",
          message: "您需要先登录哦！",
        });
        this.$router.push("/login");
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../style/index.less";
.serviceListMessage {
  margin-top: 10px;
  background: #fff;
  padding: 20px;
  align-items: center;
  .serviceListMessage_left {
    width: 365px;
    flex-shrink: 0;
    line-height: 34px;
    margin-right: 97px;
    .serviceListMessage_icon {
      color: #009999;
      font-size: 12px;
      line-height: 10px;
      margin-bottom: 10px;
    }
    h3 {
      font-size: 20px;
      cursor: pointer;
    }
    p {
      font-size: 14px;
      color: #6e6e6e;
      i {
        margin-right: 5px;
      }
    }
    .flex-center-between {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .service_money {
      margin-top: 10px;
      padding-bottom: 15px;
      border-bottom: 1px dotted #cecece;
      margin-bottom: 20px;

      button {
        width: 92px;
      }
      .service_money_box {
        font-size: 12px;
        color: #ff3b30;
        .red {
          font-weight: bold;
          font-size: 16px;
          margin: 0 5px;
        }
        .unit {
          color: #6e6e6e;
        }
      }
    }
    .serviceListMessage_btn {
      width: 100px;
      height: 30px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #009999;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      img {
        width: 13px;
        height: 13px;
        margin-right: 6px;
      }
      p {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #009999;
      }
    }
  }

  .serviceListMessage_right {
    display: grid;
    grid-template-columns: 220px 220px 220px;
    grid-column-gap: 20px;
    img {
      width: 220px;
      height: 140px;
      border-radius: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/supplyHome/components/list/serviceListMessage.vue